var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlusMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_6812)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_173_6812)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 88,
    height: 119,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 57,
    r: 13,
    fill: "#23A26D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3335 62.6667H56.6668C54.6668 62.6667 53.3335 61.6667 53.3335 59.3334V54.6667C53.3335 52.3334 54.6668 51.3334 56.6668 51.3334H63.3335C65.3335 51.3334 66.6668 52.3334 66.6668 54.6667V59.3334C66.6668 61.6667 65.3335 62.6667 63.3335 62.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3332 55L61.2465 56.6667C60.5598 57.2133 59.4332 57.2133 58.7465 56.6667L56.6665 55",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 78,
    width: 52,
    height: 5,
    rx: 2.5,
    fill: "#D8DBE6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 88,
    width: 76,
    height: 50,
    rx: 4,
    fill: "url(#paint0_linear_173_6812)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_6812",
    x1: 60,
    y1: 16.7037,
    x2: 60,
    y2: 138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DBE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8DBE6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_6812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 60,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_173_6812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 119,
    fill: "white",
    transform: "translate(16 32)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlusMail);
export default __webpack_public_path__ + "static/media/ilus-mail.f0e10b349b034e44e4a02049e386b358.svg";
export { ForwardRef as ReactComponent };